import { colors, spacings } from "@/assets/themes";
import polyglot from "@/utils/polyglot";
import Block from "../Block";
import { Body14 } from "../Text";

const SignUpTerms = () => {
  const html = polyglot.t("signup.accept_conditions.text", {
    general_condition: `<a href='/${"customer-terms"}' target='_blank'>${polyglot.t(
      "signup.accept_conditions.general_conditions"
    )}</a>`,
    privacy_policy: `<a href='/data-policy' target='_blank'>${polyglot.t(
      "signup.accept_conditions.privacy_policy"
    )}</a>`,
  });
  return (
    <Block marginTop={spacings.m}>
      <Body14 color={colors.muted}>
        <div dangerouslySetInnerHTML={{ __html: html }} />
      </Body14>
    </Block>
  );
};

export default SignUpTerms;
